import { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button, Form } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

import useAddCompatibilityModal from "pages/ProductCompatibility/components/AddCompatibilityModal/hooks/useAddCompatibilityModal";
import { REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL } from "config";

const AddCompatibilityModal = (props) => {
	const [categories, setCategories] = useState([]);
	const { addCompatibilityModalIsOpen, hideAddCompatibilityModal } =
		useAddCompatibilityModal();

	useEffect(() => {
		console.log("compatibilities", props.compatibilities);
		getCategories();
	}, [props.compatibilities]);

	const submit = async (values, { resetForm }) => {
		const compatibility = {
			...values.compatibility,
		};
		if (!props.baseProductId) {
			// baseProductId is required.
			return;
		}
		try {
			const response = await axios.post(
				`${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/base-products/${props.baseProductId}/compatibility`,
				compatibility
			);
			if (response.status === 200) {
				resetForm();
				hideAddCompatibilityModal();
				if (props.onAddedCompatibility) {
					props.onAddedCompatibility();
				}
			}
		} catch (error) {
			console.log("error: ", error);
		}
	};

	const ProductCompatibilitySchema = Yup.object().shape({
		compatibility: Yup.object().shape({
			categoryBcId: Yup.string()
				.min(1, "Too Short!")
				.required("Required"),
		}),
	});

	const formik = useFormik({
		initialValues: {
			compatibility: { categoryBcId: "" },
		},
		validateOnMount: true,
		validationSchema: ProductCompatibilitySchema,
		onSubmit: submit,
	});

	const { compatibility } = formik.values;

	const getCategories = async () => {
		try {
			const response = await axios.get(
				`${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/bc/categories`
			);
			if (response.status === 200) {
				let categories = response.data.categories;

				console.log(
					"categories",
					categories,
					"compatibilities",
					props.compatibilities
				);

				var categoryNamesToNotShow = [
					"Shop All",
					"Servers",
					"Switches",
					"Storage",
				];

				const selectableCategories = categories.filter((category) => {
					let exists = false;
					let shouldntShow = false;
					props.compatibilities.forEach((compatibility) => {
						if (compatibility.category.id === category.id) {
							exists = true;
						}
						if (
							categoryNamesToNotShow.indexOf(category.name) > -1
						) {
							shouldntShow = true;
						} else {
							console.log(
								"",
								categoryNamesToNotShow.indexOf(category.name),
								category.name
							);
						}
					});

					if (exists || shouldntShow) {
						return false;
					}
					return true;
				});

				setCategories(selectableCategories);

				// setCategories(categories);
				// Setting first category as selected on select drop-down.
				const selectedCategory = selectableCategories[0];
				formik.setFieldValue("compatibility", {
					categoryBcId: selectedCategory.id,
				});
			}
		} catch (error) {
			console.log("error: ", error);
		}
	};

	useEffect(() => {
		// getCategories(); // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Modal
			show={addCompatibilityModalIsOpen}
			onHide={hideAddCompatibilityModal}>
			<Modal.Header closeButton>
				<Modal.Title>Add Compatibility</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form onSubmit={formik.handleSubmit}>
					<Form.Group controlId="compatibility" size="lg">
						<Form.Label>Category:</Form.Label>
						<Form.Control
							as="select"
							name="compatibility"
							value={compatibility.categoryBcId}
							onChange={(e) => {
								const selectedCategory = categories.find(
									(serverProduct) =>
										serverProduct.id ===
										Number(e.target.value)
								);
								formik.setFieldValue("compatibility", {
									categoryBcId: selectedCategory.id,
								});
							}}>
							{categories.map((category) => (
								<option key={category.id} value={category.id}>
									{category.name}
								</option>
							))}
						</Form.Control>
					</Form.Group>
					<Button
						block
						size="lg"
						type="submit"
						style={{
							marginBottom: "40px",
						}}
						disabled={Object.keys(formik.errors).length !== 0}>
						Add Compatibility
					</Button>
				</Form>
			</Modal.Body>
		</Modal>
	);
};

export default AddCompatibilityModal;
